import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SetupComponent } from './setup/setup.component';
import { AuditLogComponent } from './audit-log/audit-log.component';
import { AppHeaderComponent } from './app-header/app-header.component';
import { NotfoundComponent } from './notfound/notfound.component';
import { AuthGuard } from '@guards';
import { ComponentOAuthComponent } from './component-o-auth/component-o-auth.component';
import { ComponentOAuthLoginComponent } from './component-o-auth-login/component-o-auth-login.component';
import { AssessmentOrderComponent } from './assessments/assessment-order/assessment-order.component';
import { InlineAssessmentComponent } from './assessments-investigation/inline-assessmentmain/inline-assessment.component';
import { GuestBiometricComponent } from './guest-biometric/guest-biometric.component';
import { CandidateDropdownComponent } from './candidate-dropdown/candidate-dropdown.component';
import { EmployeesComponent } from './employees/employees.component';
import { BgIndexMappingComponent } from './bg-index-mapping/bg-index-mapping.component';
import { SsoComponent } from './sso/sso.component';
import { EmailComponent } from './email/email.component';
import { ExclusionComponent } from './exclusion/exclusion.component';
import { ComplianceLayoutComponent } from './compliance-layout/compliance-layout.component';
import { CashCageComplianceLayoutComponent } from './compliance-layout/cashcage/cashcage-compliance-layout.component';
import { SecurityComplianceLayoutComponent } from './compliance-layout/security/security-compliance-layout.component';
import { AgeVerificationComponent } from './compliance-layout/cashcage/age-verification.component';
import { VddOnboardingPageComponent } from './vdd-onboarding-page/vdd-onboarding-page.component';
import { PatronSearchPageComponent } from './patron-search-page/patron-search-page.component';

const routes: Routes = [
  { path: '', loadChildren: () => import('./auth-module/auth-module.module').then(m => m.AuthModuleModule) },
  { path: 'marketplace/integration/confirm/:companyId', component: ComponentOAuthComponent },
  { path: 'marketplace/integration/:mplName', component: ComponentOAuthLoginComponent },
  { path: 'biometric_identification/:requestId', component: GuestBiometricComponent },
  { path: 'saml-login', component: SsoComponent },
  { path: 'vendor', loadChildren: () => import('./vendor-root-page/vendor-root-page.module').then(m => m.VendorRootPageModule) },
  {
    path: 'home',
    canActivateChild: [AuthGuard],
    component: AppHeaderComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'search' },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'search', loadChildren: () => import('./search-module/search.module').then(m => m.SearchModule) },
      { path: 'cross-match', loadChildren: () => import('./cross-match-module/cross-match.module').then(m => m.CrossMatchModule) },
      {
        path: 'screening-reports',
        loadChildren: () => import('./screening-report-module/screening-report.module').then(m => m.ScreeningReportModule),
      },
      { path: 'investigate', loadChildren: () => import('./investigate-module/investigate.module').then(m => m.InvestigateModule) },
      { path: 'batch-screening', loadChildren: () => import('./batch-screening-module/batch-screening.module').then(m => m.BatchScreeningModule) },
      { path: 'account-opening', loadChildren: () => import('./account-opening-module/account-opening.module').then(m => m.AccountOpeningModule) },
      { path: 'admin/flows', loadChildren: () => import('./flow-setup-module/flow-setup.module').then(m => m.FlowSetupModule) },
      { path: 'auditLog', component: AuditLogComponent },
      { path: 'setup/accesscontrol', component: SetupComponent },
      { path: 'data-loader', loadChildren: () => import('./data-loader/data-loader.module').then(m => m.DataLoaderModule) },
      { path: 'assessment-order', component: AssessmentOrderComponent },
      {
        path: 'assessment-investigation',
        loadChildren: () => import('./assessments-investigation/assessment-graph.module').then(m => m.AssessmentGraphModule),
      },
      { path: 'inline-assessment', component: InlineAssessmentComponent },
      { path: 'candidate', component: CandidateDropdownComponent },
      { path: 'employees', component: EmployeesComponent },
      { 
        path: 'employees/:candidate_id/:record_id/:name', 
        loadChildren: () => import('./entity/entity.module').then(m => m.EntityModule),
      },
      { path: 'patrons', loadChildren: () => import('./patrons-routing/patrons-routing.module').then(m => m.PatronsRoutingModule) },
      { path: 'index-mapping', component: BgIndexMappingComponent },
      { path: 'verification-mail', component: EmailComponent },
      { path: 'exclusion', component: ExclusionComponent },
      {
        path: 'compliance/cashcage',
        component: CashCageComplianceLayoutComponent,
      },
      {
        path: 'compliance/security',
        component: SecurityComplianceLayoutComponent,
      },
      {
        path: 'compliance/age-verification',
        component: AgeVerificationComponent,
      },
      {
        path: 'compliance/vdd-onboarding',
        component: VddOnboardingPageComponent,
      },
      {
        path: 'compliance/patron-search',
        component: PatronSearchPageComponent,
      },
      {
        path: 'compliance/patron-search-queue',
        loadChildren: () => import('./patron-search-queue-page/patron-search-queue-page.module').then(m => m.PatronSearchQueuePageModule),
      },
      {
        path: 'compliance/vendors',
        loadChildren: () => import('./vendors-page/vendors-page.module').then(m => m.VendorsPageModule),
      },
      {
        path: 'compliance/third-party',
        loadChildren: () => import('./third-party-page/third-party-page.module').then(m => m.ThirdPartyPageModule),
      },
      {
        path: 'compliance/:page',
        component: ComplianceLayoutComponent,
      },
      { path: '', redirectTo: '/home/compliance/vdd', pathMatch: 'full' },
    ],
  },
  { path: '**', component: NotfoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes), CommonModule, BrowserModule, FormsModule],
  exports: [RouterModule],
})
export class AppRoutingModule {}
